<template>
    <div class="modal-mask" ref="root"
         :style="modalMaskStyle">
      <div class="modal-wrapper">
        <div :class="'modal-container ' + modalContainerClass" ref="el"
             :style="elConfig.data.style">
          <div class="layer-wrap" style="border: 0px;">
            <div class="layer-header"
                 v-if="isHeader"
                 @mouseup="popupHeader.mouseup()"
                 @mousedown="popupHeader.mousedown()">
              <span class="bold">{{ header }}</span>
              <button class="f-right"
                      v-if="isClose"
                      style="line-height: 36px;"
                      @click="btnClose_click()">
                <div class="img-com __del01">
                  <span>닫기</span>
                </div>
              </button>
            </div>
            <div class="layer-content"
                 :style="contentStyle">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import {onMounted, defineProps, ref, reactive, defineEmits} from 'vue';
import {useDraggable} from "@vueuse/core";

const emits = defineEmits(['close']);

const props = defineProps({
  popupOpts: {
    type: Object,
  },
});

const isHeader = ref(true);
const header = ref('');
const isClose = ref(true);
const modalContainerClass = ref('');
const modalMaskStyle = ref({});
const contentStyle = ref({});

const initPopupOpts = () => {
  const {popupOpts} = props;

  if (popupOpts.isHeader != null) isHeader.value = popupOpts.isHeader;
  if (popupOpts.header) header.value = popupOpts.header;
  if (popupOpts.isClose != null) isClose.value = popupOpts.isClose;
  if (popupOpts.modalContainerClass) modalContainerClass.value = popupOpts.modalContainerClass;
  if (popupOpts.modalMaskStyle) modalMaskStyle.value = popupOpts.modalMaskStyle;
  if (popupOpts.contentStyle) contentStyle.value = popupOpts.contentStyle;
}

const btnClose_click = () => {
  emits('close');
 }

const el = ref(null);
const elConfig = {
  data: reactive({
    class: '',
    style: '',
    dragStyle: null,
    isDragActive: false,
  }),
  moveEvent() {
    if (elConfig.data.isDragActive) {
      elConfig.data.style = elConfig.data.dragStyle + 'position:fixed;';
    }
  },
  endEvent() {
    const left = el.value.style.left.replace('px', '');
    const top = el.value.style.top.replace('px', '');

    const clientHeight = el.value.clientHeight;
    const clientWidth = el.value.clientWidth;

    const windowInnerHeight = window.innerHeight;
    const windowInnderWidth = window.innerWidth;

    if (Number(left) < 0) {
      el.value.style.left = '10px';
    }

    if (Number(top) < 0) {
      el.value.style.top = '10px';
    }

    if (Number(left) + clientWidth > windowInnderWidth) {
      el.value.style.left = (windowInnderWidth - clientWidth - 10) + 'px';
    }

    if (Number(top) + clientHeight > windowInnerHeight) {
      el.value.style.top = (windowInnerHeight - clientHeight - 10) + 'px';
    }
  },
};

const mode = ref('hold');
const popupHeader = {
  data: reactive({}),
  mouseup() {
    elConfig.data.isDragActive = false;
  },
  mousedown() {
    if (mode.value == 'hold') {
      let top = (window.innerHeight - el.value.clientHeight) / 2;
      let left = (window.innerWidth - el.value.clientWidth) / 2;

      if (top < 10) {
        top = 10;
      }

      if (left < 10) {
        left = 10;
      }

      el.value.style.top = top + 'px';
      el.value.style.left = left + 'px';

      mode.value = 'drag';
    } else {
      elConfig.data.isDragActive = true;
    }
  },
};

onMounted( () => {
  const { style } = useDraggable(el, {
    onMove: elConfig.moveEvent,
    onEnd: elConfig.endEvent,
  });

  elConfig.data.dragStyle = style;
  elConfig.data.class = ' __drag';

  initPopupOpts();
});

</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 1280px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  display: table;
  overflow: hidden;
}

.layer-wrap {
  border: 1px solid #e0e0e0;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.layer-wrap .layer-header {
  padding: 0 14px;
  height: 35px;
  line-height: 36px;
  font-size: 16px;
}

.layer-wrap .layer-content {
  border-top: 1px solid #e0e0e0;
  padding: 10px 14px;
}
</style>
